export default __webpack_public_path__ + "static/media/3bl1gr.2712cbfa.svg";